var VehicleViewModal = (function (base) {
  __extends(VehicleViewModal, base);

  function VehicleViewModal(apiClient) {
    var self = base.call(this, apiClient) || this;
    return self;
  };

  VehicleViewModal.prototype.activate = function (vehicleId, deleteFunc, showOnMapFunc) {
    const self = this;

    this.loadContent(`api/vehicles/${vehicleId}`)
      .then($modal => {
            VehicleHistory.Init($modal, vehicleId, true);

            $modal

                //Кнопка `Удалить`
                .on('click', '[js=delete]', function() {
                    if (confirm(`Вы действительно хотите удалить это транспортное средство?`)) {
                        deleteFunc(vehicleId);
                    }
                })

                //Кнопка `Показать на карте`
                .on('click', '[js=show-on-map]', function() {
                    showOnMapFunc(vehicleId);
                })

                //Кнопка `Редактировать`
                .on('click', '[js=edit]', function() {
                    ModalConductor.activate(VehicleEditModal, vehicleId)
                        .on('closed', (modalResult) => {
                            $('#VehicleListItemTable').DataTable().ajax.reload(null, false);
                            vehicleId = modalResult.id ? modalResult.id : vehicleId;
                            self.reloadContent(`api/vehicles/${vehicleId}`)
                                .then(() => VehicleHistory.Init($modal, vehicleId, true));
                        });
                });
        });
  };

  return VehicleViewModal;
}(BaseModal));
